import { Menu, MenuItem, Typography, styled, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { DeleteButtonNewIcon, PlusBlueIconNew } from '../../assets/images';
import { EFaultType, VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS, VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR } from '../../constants';
import './vehicleStructure.css';
import { systemColor } from '../../theme/systemColor';
var Circle = styled('span')(function (_ref) {
    var theme = _ref.theme;
    return {
        borderRadius: "50%",
        height: "16px",
        width: "16px",
        display: "block",
        marginTop: "2px",
        marginRight: "8px"
    };
});
export var VehicleConditionRightView = function (props) {
    var precheckList = props.precheckList, imageAttachment = props.imageAttachment, onChange = props.onChange, onRemove = props.onRemove, isDisabled = props.isDisabled;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = useState(null), selectedItem = _b[0], setSelectedItem = _b[1];
    var _c = useState(precheckList), list = _c[0], setList = _c[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    useEffect(function () {
        setList(precheckList);
    }, [precheckList]);
    var handleClick = function (event, item) {
        setSelectedItem(item);
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
        setSelectedItem(null);
    };
    var onScrachClick = function (event) {
        setAnchorEl(null);
        if (selectedItem && onChange) {
            onChange(selectedItem, EFaultType.Scratch);
        }
    };
    var onDamageClick = function () {
        setAnchorEl(null);
        if (selectedItem && onChange) {
            onChange(selectedItem, EFaultType.Damage);
        }
    };
    var onMissingClick = function () {
        setAnchorEl(null);
        if (selectedItem && onChange) {
            onChange(selectedItem, EFaultType.Missing);
        }
    };
    var getAnswerColor = function (PrecheckOptionItem) {
        var keysWithTrueDefaultValue = PrecheckOptionItem.Answers.find(function (answer) { return !!answer.defaultValue; });
        if (keysWithTrueDefaultValue && keysWithTrueDefaultValue.Key) {
            return VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR[keysWithTrueDefaultValue.Key.toLocaleUpperCase()];
        }
        else {
            return 'white';
        }
    };
    var onClickRemove = function () {
        setAnchorEl(null);
        if (selectedItem) {
            var Value = selectedItem.Answers.find(function (item) { return item.defaultValue; });
            if (Value && onRemove) {
                onRemove(selectedItem, Value.Key);
            }
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative',
            width: VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS.WIDTH,
            height: VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS.HEIGHT,
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative',
            width: VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS.WIDTH,
            height: VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS.HEIGHT,
            display: 'block',
            // aspectRatio: "2/3",
            backgroundSize: "contain",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: "center center",
            backgroundImage: "url(".concat(imageAttachment, ")")
        }
    }, list.map(function (i) {
        if (i.ImageXPostion && i.ImageYPostion) {
            return /*#__PURE__*/ React.createElement("span", {
                style: {
                    position: "absolute",
                    left: "".concat(i.ImageXPostion - VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS.RADIUS, "px"),
                    top: "".concat(i.ImageYPostion - VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS.RADIUS, "px"),
                    borderRadius: "50%",
                    height: VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS.RADIUS * 2,
                    width: VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS.RADIUS * 2,
                    border: getAnswerColor(i) === 'white' ? "solid 2px ".concat(systemColor.primary, " ") : "none",
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    backgroundColor: getAnswerColor(i),
                    opacity: isDisabled && getAnswerColor(i) === 'white' ? 0.5 : 1
                },
                onClick: function (e) {
                    if (!isDisabled) {
                        handleClick(e, i);
                    }
                }
            }, getAnswerColor(i) === 'white' && /*#__PURE__*/ React.createElement("img", {
                height: '16px',
                width: "16px",
                src: PlusBlueIconNew
            }));
        }
        else {
            return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    })))), /*#__PURE__*/ React.createElement(Menu, {
        disableScrollLock: true,
        id: "basic-menu",
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: handleClose,
        MenuListProps: {
            "aria-labelledby": "basic-button"
        },
        anchorOrigin: {
            vertical: "center",
            horizontal: "right"
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            padding: "5px  10px 5px 10px"
        },
        variant: "h5"
    }, selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.Question), /*#__PURE__*/ React.createElement(MenuItem, {
        sx: {
            minHeight: "30px"
        },
        onClick: onScrachClick
    }, /*#__PURE__*/ React.createElement(Circle, {
        style: {
            backgroundColor: VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR.SCRATCH
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("Scratch"))), /*#__PURE__*/ React.createElement(MenuItem, {
        sx: {
            minHeight: "30px"
        },
        onClick: onDamageClick
    }, /*#__PURE__*/ React.createElement(Circle, {
        style: {
            backgroundColor: VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR.DAMAGE
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("Damage"))), /*#__PURE__*/ React.createElement(MenuItem, {
        sx: {
            minHeight: "30px"
        },
        onClick: onMissingClick
    }, /*#__PURE__*/ React.createElement(Circle, {
        style: {
            backgroundColor: VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR.MISSING
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("Missing"))), selectedItem && getAnswerColor(selectedItem) !== 'white' && /*#__PURE__*/ React.createElement(MenuItem, {
        sx: {
            minHeight: "30px"
        },
        onClick: onClickRemove
    }, /*#__PURE__*/ React.createElement("img", {
        src: DeleteButtonNewIcon
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("Remove")))));
};
